export const toCents = (amountUsd) => {
  return Math.round(Number(amountUsd) * 100);
};

export const fromCents = (cents) => {
  return Number((cents / 100).toFixed(2));
};

export const splitPartnerCompany = ({
  lineAmountUsd,
  totalPartnerPercent, // 0..1
}) => {
  const totalCents = toCents(lineAmountUsd);
  const partnerCentsRaw = Math.round(totalCents * totalPartnerPercent);
  let partnerCents = partnerCentsRaw;
  let companyCents = totalCents - partnerCents;
  // Ensure last cent goes to company if rounding drift
  if (partnerCents + companyCents !== totalCents) {
    companyCents = totalCents - partnerCents;
  }
  return { partnerUsd: fromCents(partnerCents), companyUsd: fromCents(companyCents) };
};

export const splitProRata = ({ appliedUsd, totalUsd, totalPartnerPercent }) => {
  const appliedCents = toCents(appliedUsd);
  const totalCents = toCents(totalUsd);
  if (totalCents <= 0) return { partnerUsd: 0, companyUsd: 0 };
  const ratio = appliedCents / totalCents;
  const partnerCentsRaw = Math.round(totalCents * totalPartnerPercent * ratio);
  let partnerCents = partnerCentsRaw;
  let companyCents = appliedCents - partnerCents;
  if (partnerCents + companyCents !== appliedCents) {
    companyCents = appliedCents - partnerCents;
  }
  return { partnerUsd: fromCents(partnerCents), companyUsd: fromCents(companyCents) };
};


